/*
 * @Date: 2020-03-09 21:30:19
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-10 21:40:59
 * @FilePath: /rongxin.web/src/views/home/about-us/index.js
 */
import Service from './servece.js';
export default {
  data() {
    return {
      params: {
        limit: '10',
        homePage: 1, // 只要首页推荐的数据
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '61af319c1672119f533e28ad'
      }
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      Service.getNewsList(this.params).then(data => {
        this.newsArr = data.data && data.data.list.slice(0, 3);
      });
    },
    goAbout() {
      this.$router.push({path: 'aboutUsDetail'});
    }
  }
};
